import { render, staticRenderFns } from "./price-info.vue?vue&type=template&id=0c46ae44&"
import script from "./price-info.vue?vue&type=script&lang=js&"
export * from "./price-info.vue?vue&type=script&lang=js&"
import style0 from "./price-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports